import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/service/api.service';
import * as _ from 'lodash';


@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css']
})
export class AdminComponent implements OnInit {
 

  
  constructor(
    public apiService:ApiService
  ) { 
    // this.apiService.getAllData()
    // .then((resp:any) =>{
    //   resp.result.map((data:any)=>{
    //     this.notices.push(data);
    //   })
    // })

    
  }

  

  ngOnInit(): void {
  }

}
